import { render, staticRenderFns } from "./esta_segui_persegui.vue?vue&type=template&id=01b9e5da"
import script from "./esta_segui_persegui.vue?vue&type=script&lang=js"
export * from "./esta_segui_persegui.vue?vue&type=script&lang=js"
import style0 from "./esta_segui_persegui.vue?vue&type=style&index=0&id=01b9e5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports